import axios from "axios";
import React, { useState, useEffect } from "react";
import { AudioRecorder } from "react-audio-voice-recorder";
import { TTS_API_URL } from "routes/api";
import Analytics from "utils/analytics";
const API_AUDIO = TTS_API_URL;

function AudioPage() {
  const [file, setFile] = useState(null);
  const [recordingStartTime, setRecordingStartTime] = useState(null);

  useEffect(() => {
    // Track page view when component mounts
    Analytics.trackPageView('Audio Page', window.location.pathname);
  }, []);

  const handleSendFile = async () => {
    if (!file) return;

    Analytics.trackButtonClick('Send Audio File', 'Audio Page');
    Analytics.trackFeatureUsage('Audio Upload', {
      method: 'file_upload',
      fileSize: file.size,
      fileType: file.type
    });

    const formatData = new FormData();
    if (file) {
      formatData.append("upload_file", file, "audio.mp3");
      if (file) {
        try {
          const res = await axios.post(`${API_AUDIO}transcription`, formatData);
          Analytics.trackCustomEvent('Audio Transcription Success', {
            method: 'file_upload',
            responseTime: Date.now() - (file.lastModified || Date.now())
          });
        } catch (error) {
          Analytics.trackError('Audio Transcription Error', error.message, 'Audio Upload');
        }
      }
    }
  };

  //   const addAudioElement = (blob) => {
  //     const url = URL.createObjectURL(blob);
  //     const audio = document.createElement("audio");

  //     audio.src = url;
  //     audio.controls = true;
  //     document.body.appendChild(audio);
  //   };

  // const addAudioElement = async (blob) => {
  //   const url = URL.createObjectURL(blob);
  //   const audio = document.createElement("audio");
  //   audio.src = url;
  //   audio.controls = true;
  //   document.body.appendChild(audio);

  //   // Créer un objet FormData et ajouter le blob
  //   const formData = new FormData();
  //   formData.append("upload_file", blob, "audio.webm");

  //   try {
  //     // Envoyer le fichier à l'API
  //     const res = await axios.post(`${API_AUDIO}transcription`, formData);
  //     console.log("Réponse de l'API:", res);
  //   } catch (error) {
  //     console.error("Erreur lors de l'envoi du fichier audio", error);
  //   }
  // };

  // Fonction pour ajouter un élément audio et uploader le blob
  const addAudioElement = async (blob) => {
    const recordingDuration = recordingStartTime ? Date.now() - recordingStartTime : 0;
    setRecordingStartTime(null);

    // Track recording complete
    Analytics.trackMediaComplete('audio_recording', 'user_recording');
    Analytics.trackFeatureUsage('Audio Recording Complete', {
      duration: recordingDuration,
      blobSize: blob.size
    });

    // Créer une URL pour le blob
    const url = URL.createObjectURL(blob);
    const audio = document.createElement("audio");
    audio.src = url;
    audio.controls = true;
    document.body.appendChild(audio);

    // Créer un objet FormData et ajouter le blob
    const formData = new FormData();
    formData.append("upload_file", blob, "audio.mp3");

    try {
      // Track API call start
      const apiStartTime = Date.now();

      // Envoyer le fichier à l'API
      const res = await axios.post(`${API_AUDIO}transcription`, formData);

      // Track successful transcription
      Analytics.trackCustomEvent('Audio Transcription Success', {
        method: 'live_recording',
        responseTime: Date.now() - apiStartTime,
        recordingDuration
      });
    } catch (error) {
      Analytics.trackError('Audio Transcription Error', error.message, 'Live Recording');
    }
  };

  // Track when recording starts
  const handleRecordingStart = () => {
    setRecordingStartTime(Date.now());
    Analytics.trackMediaPlay('audio_recording', 'user_recording', 0);
    Analytics.trackFeatureUsage('Audio Recording Start');
  };

  return (
    <div>
      AudioPage
      <input
        type="file"
        name="audio"
        id="audio"
        onChange={(e) => {
          const selectedFile = e.target?.files[0];
          if (selectedFile) {
            Analytics.trackCustomEvent('Audio File Selected', {
              fileSize: selectedFile.size,
              fileType: selectedFile.type
            });
            setFile(selectedFile);
          }
        }}
      />
      <button onClick={handleSendFile}>envoyer</button>
      <AudioRecorder
        onRecordingComplete={addAudioElement}
        onRecordingStart={handleRecordingStart}
        audioTrackConstraints={{
          noiseSuppression: true,
          echoCancellation: true,
        }}
        downloadOnSavePress={true}
        downloadFileExtension="mp3"
        showVisualizer
      />
    </div>
  );
}

export default AudioPage;
